export const pascalToCamelCase = (s: string) => {
    const firstLetter = s[0].toLowerCase()
    const rest = s.substring(1, s.length)
    return `${firstLetter}${rest}`
}
